<template lang="html">
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <v-card-text>
            <v-container fluid grid-list-md class="grey lighten-4">
              <h2>Os seguintes recursos estão disponíveis em caso de dúvidas:</h2>
              <br>
              <v-layout row wrap>
                <v-flex>
                  <v-card >
                    <v-card-title>Perguntas Frequentes:</v-card-title>
                    <v-card-text>
                      <p>Respostas para as dúvidas mais comuns sobre o sistema e procedimentos realizados pela PROEX.</p>
                      <!-- <a href="./../static/Perguntas Frequentes.pdf" target="_blank">Perguntas Frequentes</a> -->
                      <p>Em atualização</p>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-card >
                    <v-card-title>Orientações Gerais:</v-card-title>
                    <v-card-text>
                      <!--p>Está com dúvidas sobre como registrar uma ação de extensão, encaminhar o relatório de atividades ou solicitar os certificados? Acesse os arquivos abaixo:</!--p>
                      <a href="./../static/Anexo I - Registro de Ações de Extensão e Lives.pdf" target="_blank">Anexo I - Registro de Ações de Extensão e Lives</a>
                      <br>
                      <a href="./../static/Orientações para o envio de relatório das ações de extensão.pdf" target="_blank">Anexo II - Relatório de Extensão</a>
                      <br>
                      <a href="./../static/Anexo III - Solicitação de Certificados.pdf" target="_blank">Anexo III - Solicitação de Certificados</a>
                      <br>
                      <a href="./../static/Anexo IV - Procedimento para transformar Programa em Projeto de Extensão.pdf" target="_blank">Anexo IV - Procedimento para transformar Programa em Projeto de Extensão</a>
                      <br>
                      <a href="./../static/Anexo V - Procedimento para alterar a coordenação de Ações de Extensão.pdf" target="_blank">Anexo V - Procedimento para alterar a coordenação de Ações de Extensão</a>
                      <br>
                      <a href="./../static/Checklist - Registro de Ações de Extensão.pdf" target="_blank">Checklist - Registro de Ações de Extensão</a>
                      <br>
                      <a href="./../static/Checklist - Relatório de Extensão.pdf" target="_blank">Checklist - Relatório de Extensão</a>
                      <br>
                      <a href="./../static/Procedimentos - Divisão de Fomento.pdf" target="_blank">Procedimentos e orientações da Divisão de Fomento</a>
                      <br>
                      <a href="./../static/Como consultar-pesquisar ações no portal.pdf" target="_blank">Como pesquisar ações de extensão no Portal de Projetos</a>
                      <br>
                      <a href="./../static/Resolução CEPE.PROEX 46-2014.pdf" target="_blank">Resolução CEPE.PROEX 46-2014</a>
                      <br>
                      <a href="./../static/Resolução CNE 07-2018.pdf" target="_blank">Resolução CNE 07-2018</a>
                      <br>
                      <br-->
                      <p>Para obter maiores informações sobre os Objetivos de Desenvolvimento Sustentável (ODS), clique nos links abaixo:</p>
                      <a href="https://ods.ufes.br/" target="_blank">UFES - Objetivos de Desenvolvimento Sustentável</a>
                      <br>
                      <a href="https://brasil.un.org/pt-br/sdgs" target="_blank">Nações Unidas - Objetivos de Desenvolvimento Sustentável no Brasil</a>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-card >
                    <v-card-title>Fale Conosco:</v-card-title>
                    <v-card-text>
                      <p>
                        Dúvidas sobre preenchimento devem ser encaminhadas para
                        <a href="mailto:suporte.proex@ufes.br">suporte.proex@ufes.br</a>.
                        Já problemas no portal podem ser direcionados para
                        <a href="https://atendimento.ufes.br/" target="_blank" rel="noopener noreferrer">
                          atendimento.ufes.br.
                        </a>
                      </p>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'ajuda'
  }
</script>



// WEBPACK FOOTER //
// ajuda.vue?e57fcca4